import { Row, Typography, Button, Dropdown, Menu, Modal } from "antd";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import { useNavigate, Link } from "react-router-dom";

import { ConsulateColumn } from "components/Columns";
import Table from "components/common/Table";
import { useSelector, useDispatch } from "react-redux";
import { useQuery } from "hooks";
import {
  getAllConsulateRequest,
  setSelectedConsulateIds,
  updateActiveConsulateRequest,
  deleteConsulateRequest,
} from "providers/ConsulateProvider/slice";

import "./styles.less";
import { EllipsisOutlined } from "@ant-design/icons";
import SearchBar from "./SearchBar";

const ConsulateList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const docs = useSelector((state) => _get(state, "consulate.docs"));
  const totalDocs = useSelector((state) => _get(state, "consulate.totalDocs"));
  const isLoading = useSelector((state) => _get(state, "consulate.isLoading"));
  const selectedRowKeys = useSelector((state) =>
    _get(state, "consulate.selectedRowKeys", [])
  );
  const selectedRows = useSelector((state) =>
    _get(state, "consulate.selectedRows", [])
  );
  const isDisableActivateBtn = !!selectedRows.find(
    (item) => item.isActive === true
  );
  const isDisableDeactivateBtn = !!selectedRows.find(
    (item) => item.isActive === false
  );

  const [searchObject] = useQuery(getAllConsulateRequest, {
    arrayParams: ["isActive"],
  });

  const handleDelete = (idCategory) => {
    Modal.confirm({
      title: "Xác nhận xóa",
      content: "Bạn có chắc chắn muốn xóa danh mục này?",
      okText: "Xóa",
      cancelText: "Hủy",
      okType: "danger",
      onOk: () =>
        dispatch(
          deleteConsulateRequest({ idCategory: [idCategory] })
        ).then(() => dispatch(getAllConsulateRequest(searchObject))),
    });
  };

  const menuAll = () => (
    <Menu>
      <Menu.Item
        disabled={isDisableActivateBtn || _isEmpty(selectedRowKeys)}
        onClick={() =>
          dispatch(
            updateActiveConsulateRequest({
              isActive: true,
              idCategory: selectedRowKeys,
            })
          ).then(() => dispatch(getAllConsulateRequest(searchObject)))
        }
      >
        Kích hoạt
      </Menu.Item>
      <Menu.Item
        disabled={isDisableDeactivateBtn || _isEmpty(selectedRowKeys)}
        onClick={() =>
          dispatch(
            updateActiveConsulateRequest({
              isActive: false,
              idCategory: selectedRowKeys,
            })
          ).then(() => dispatch(getAllConsulateRequest(searchObject)))
        }
      >
        Vô hiệu hóa
      </Menu.Item>
      <Menu.Item
        disabled={_isEmpty(selectedRowKeys)}
        onClick={() => {
          Modal.confirm({
            title: "Xác nhận xóa",
            content: `Bạn có chắc chắn muốn xóa ${selectedRowKeys.length} danh mục?`,
            okText: "Xóa",
            cancelText: "Hủy",
            okType: "danger",
            onOk: () =>
              dispatch(
                deleteConsulateRequest({ idCategory: selectedRowKeys })
              ).then(() => dispatch(getAllConsulateRequest(searchObject))),
          });
        }}
      >
        Xóa
      </Menu.Item>
    </Menu>
  );

  const menu = (record) => {
    const { _id } = record;
    return (
      <Menu>
        <Menu.Item>
          <Link
            to={`/consulate/consulate_categories/${_id}`}
            state={{ canGoBack: true }}
          >
            Chi tiết
          </Link>
        </Menu.Item>
        <Menu.Item
          disabled={record.isActive === true}
          onClick={() =>
            dispatch(
              updateActiveConsulateRequest({
                isActive: true,
                idCategory: [_id],
              })
            ).then(() => dispatch(getAllConsulateRequest(searchObject)))
          }
        >
          Kích hoạt
        </Menu.Item>
        <Menu.Item
          disabled={record.isActive === false}
          onClick={() =>
            dispatch(
              updateActiveConsulateRequest({
                isActive: false,
                idCategory: [_id],
              })
            ).then(() => dispatch(getAllConsulateRequest(searchObject)))
          }
        >
          Vô hiệu hóa
        </Menu.Item>
        <Menu.Item onClick={() => handleDelete(_id)}>Xóa</Menu.Item>
      </Menu>
    );
  };

  const actionButtons = (record) => (
    <Dropdown overlay={() => menu(record)} placement="bottomLeft" arrow>
      <Button
        className="see-more-btn"
        type="ghost"
        icon={<EllipsisOutlined style={{ fontSize: 20 }} />}
      />
    </Dropdown>
  );

  const rowSelection = {
    selectedRowKeys,
    onSelect: (record, selected, _selectedRows) => {
      dispatch(
        setSelectedConsulateIds({
          record,
          selected,
          selectedRows: _selectedRows,
        })
      );
    },
    onSelectAll: (selected, _selectedRows, changeRows) => {
      dispatch(
        setSelectedConsulateIds({
          selected,
          selectedRows: _selectedRows,
          changeRows,
        })
      );
    },
  };

  const columns = [
    ConsulateColumn.id,
    ConsulateColumn.createdAt,
    ConsulateColumn.title,
    ConsulateColumn.emoji,
    ConsulateColumn.isActive,
    {
      title: (
        <Dropdown overlay={menuAll} placement="bottomLeft" arrow>
          <Button
            size="large"
            className="see-more-btn"
            type="ghost"
            icon={<EllipsisOutlined style={{ fontSize: 20 }} />}
          />
        </Dropdown>
      ),
      width: 100,
      render: (record) => actionButtons(record),
    },
  ];

  return (
    <div className="consulate-list-wrapper">
      <Row className="consulate-list-header" justify="space-between">
        <Typography.Title level={4}>
          Danh sách thủ tục lãnh sự
        </Typography.Title>
        <Button
          size="large"
          type="primary"
          onClick={() =>
            navigate("/consulate/consulate_categories/create", {
              state: { canGoBack: true },
            })
          }
        >
          Tạo bài
        </Button>
      </Row>
      <div className="content-container">
        <SearchBar />
        <Table
          rowSelection={rowSelection}
          scroll={{ x: 1000 }}
          loading={isLoading}
          bordered
          columns={columns}
          dataSource={docs}
          rowKey={(data) => data._id}
          total={totalDocs}
          onRow={(record) => ({
            onDoubleClick: () => {
              navigate(`/consulate/consulate_categories/${record._id}`, {
                state: { canGoBack: true },
              });
            },
          })}
        />
      </div>
    </div>
  );
};

export default ConsulateList;
